import { Breadcrumbs, styled, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const StyledTypography = styled(Typography)({
  fontSize: '14px',
  fontWeight: '550',
  letterSpacing: 0,
});

const AppBreadcrumbs: React.FC = () => {
  const location = useLocation();
  const [pathName, setPathName] = useState('');

  useEffect(() => {
    let pathName = location.pathname?.split('/').pop()?.replace('-', ' ');
    pathName = pathName?.charAt(0)?.toUpperCase() + (pathName?.slice(1) ?? '');
    setPathName(pathName);
  }, [location.pathname]);

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <StyledTypography>UI Manager</StyledTypography>
      <StyledTypography >{pathName}</StyledTypography>
    </Breadcrumbs>
  );
};

export default AppBreadcrumbs;

